import lodashDebounce from "lodash.debounce"

export const debounce = (...parameters) => lodashDebounce(...parameters)

export default debounce
